import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";

function ManualDef3({ setTutorial }) {
  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      <div className={`${styles["foreground"]} ${styles["foreground-3"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              Great job! Notice the red error icon on the top-left corner of your parameter? That
              just means every parameter needs at least one choice to work. Let's add two choices
              now. Click the 'Add Choice' button to start. Once you add the first one, simply press
              Enter to quickly add another!
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default ManualDef3;
